module.exports = __webpack_public_path__ + "img/2037271848.102ea26d.gif";